<template>
  <BaseNode v-bind="props" class="question-node">
    <template #header>
      <BaseHtmlContent class="node__title" :html="processText(node.title, decisionTree.context)" />
    </template>
    <template #body>
      <BaseHtmlContent class="node__message" :html="node.message" />
      <BaseTileGrid class="question-node-grid" width-breakpoints="50ch" v-if="node.isRadioInputType">
        <template v-for="answer in node.answers">
          <BaseTileGridItem class="answer" type="radio">
            <BaseRadioButton v-model="node.selectedAnswerId" :label="answer.title" :value="answer.id" />
          </BaseTileGridItem>
          <BaseHtmlContent class="node__description --tile-grid" :html="answer.description" />
        </template>
      </BaseTileGrid>
      <div v-else>
        <BaseSelect v-model="node.selectedAnswerId" :options="options"></BaseSelect>
        <BaseHtmlContent
          v-if="node.selectedAnswer?.description"
          class="node__description --selected-answer"
          :html="node.selectedAnswer.description"
        />
      </div>
    </template>
  </BaseNode>
</template>

<script setup>
import { useSnippetProcessor } from "../../composables/useSnippetProcessor";
import { computed } from "vue";

const props = defineProps({
  node: {
    type: Object,
    required: true,
  },
  decisionTree: {
    type: Object,
    required: true,
  },
});

const options = computed(() =>
  props.node.answers.map((answer) => ({
    label: answer.title,
    value: answer.id,
  })),
);

const { processText } = useSnippetProcessor();
</script>

<style lang="scss" scoped>
.question-node-grid {
  --sp-dtv-tile-grid-columns: 1; // smaller than 50ch == stacked layout

  // MODIFIERS
  &.--sp-bp-width-gt-50ch {
    --sp-dtv-tile-grid-columns: 2; // greater than 50ch change to column layout
    .answer {
      grid-row: 1 / 2;
      height: auto;
    }
  }
  .node__description {
    &.--tile-grid {
      --sp-dtv-node-description-padding: 0 var(--sp-dtv-tile-grid-item-padding, 0.75rem);
    }
  }
}
.node__description.--selected-answer {
  --sp-dtv-node-description-padding: 1rem;
}
</style>
